import { buildEvent } from '../utils';

export const FEE_EVENT = buildEvent('fee', 'FeeEvent');
